/**
 * @generated SignedSource<<112a4f10fbf55398dfe3266e3e8bd072>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useBadgeSyncQuery$variables = Record<PropertyKey, never>;
export type useBadgeSyncQuery$data = {
  readonly currentUser: {
    readonly unviewedLikesCount: number | null | undefined;
    readonly unviewedMatchMessagesCount: number | null | undefined;
    readonly unviewedSystemMessagesCount: number | null | undefined;
  } | null | undefined;
  readonly currentUserUnreadCount: number | null | undefined;
};
export type useBadgeSyncQuery = {
  response: useBadgeSyncQuery$data;
  variables: useBadgeSyncQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentUserUnreadCount",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unviewedLikesCount",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unviewedMatchMessagesCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unviewedSystemMessagesCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useBadgeSyncQuery",
    "selections": [
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useBadgeSyncQuery",
    "selections": [
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ff348e74896380caedc99303e9cac1b0",
    "id": null,
    "metadata": {},
    "name": "useBadgeSyncQuery",
    "operationKind": "query",
    "text": "query useBadgeSyncQuery {\n  currentUserUnreadCount\n  currentUser {\n    unviewedLikesCount\n    unviewedMatchMessagesCount\n    unviewedSystemMessagesCount\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "49854f95ca0387e46d7a83c48c88ff65";

export default node;
